import { createFileRoute } from "@tanstack/react-router";

import { KennisbankLayout } from "@/features/kennisbank";

export const Route = createFileRoute("/_authenticated/kennisbank")({
	component: KennisbankLayout,
});
